export class DataTableColumn {
    Field: string;
    SortField: string;
    Header: string;
    WidthStyle: string;
    Sortable: boolean;
}